import { __ } from '@wordpress/i18n';
import Demo from '../../dashboard/content/demo';

export const ImportDemo = ({ updateProgress, WizardFooter }) => {
    return <div className="template-install">
        <div className="template-title">
            <h1 className="content-title">{__('Start With a Prebuilt Demo', 'jkit')}</h1>
            <p>{__('Want to skip the blank canvas? Choose from our ready-to-use demos and get started in minutes.', 'jkit')}</p>
        </div>
        <Demo origin="wizard" />
        <div id="jkit-dashboard-import"></div>
        <div className="wizard-actions">
            <WizardFooter updateProgress={updateProgress} next={{progress:'upgradePro', step: 2}}  back={{progress:'gettingStarted', step: 0}} />
        </div>
    </div>;
};